import React from "react";
import {
  connectorLogoNeedsDarkBackdrop,
  DEFAULT_CONNECTOR_ICON_URL,
} from "../../../utils/connectorIcons";
import { LogoFrame, LogoImage } from "./ConnectorLogo.styles";
import { swapToFallbackSource } from "./ConnectorLogo.utils";
import type { ConnectorLogoProps } from "./ConnectorLogo.types";

export const ConnectorLogo: React.FC<ConnectorLogoProps> = ({
  src,
  name,
  size = "md",
  decorative = false,
  fallbackSrc = DEFAULT_CONNECTOR_ICON_URL,
  className,
  onError,
}) => (
  <LogoFrame
    $size={size}
    $darkBackdrop={connectorLogoNeedsDarkBackdrop(src || fallbackSrc)}
    className={className}
  >
    <LogoImage
      src={src || fallbackSrc}
      alt={decorative ? "" : `${name} logo`}
      loading="lazy"
      onError={(event) => {
        swapToFallbackSource(event, fallbackSrc);
        onError?.();
      }}
    />
  </LogoFrame>
);

export default ConnectorLogo;
